export type NumericRange = 'nonnegative';

export interface ValueConstraints {
  numeric_range?: NumericRange;
}

export function getNumericInputMin(
  constraints?: ValueConstraints
): number | undefined {
  if (constraints?.numeric_range === 'nonnegative') {
    return 0;
  }
  return undefined;
}

export function mergeNumericMin(
  schemaMin?: number,
  layoutMin?: number
): number | undefined {
  if (schemaMin !== undefined && layoutMin !== undefined) {
    return Math.max(schemaMin, layoutMin);
  }
  return schemaMin ?? layoutMin;
}
